import { AuthProvider } from "react-oidc-context";

export const ReactCogniteAuthProvider = AuthProvider;